import React, { useEffect, useState } from 'react';
import ConfigModal from '../ConfigModal';
import PropTypes from 'prop-types';
import { getOrganizations } from '../../utils/api.js';
import OrganizationSelect from '../OrganizationSelect';

const OrganizationChangeModal = ({ open, organizationId, onCancel, onSubmit }) => {
	const [organizations, setOrganizations] = useState([]);

	useEffect(() => {
		const loadOrganizations = async () => {
			if (organizations.length === 0) {
				const result = (await getOrganizations()) || [];

				setOrganizations(result.filter((org) => org.id != organizationId));
			}
		};

		loadOrganizations();
	}, []);

	return (
		<ConfigModal
			title={`Flytta konto`}
			open={open}
			onSubmit={onSubmit}
			onCancel={onCancel}
			values={{
				id: null,
			}}
			disableMask
			formItems={[
				{
					id: 'id',
					label: 'Ny kund',
					decorator: {
						rules: [{ required: true, message: 'Kund är obligatorisk' }],
					},
					component: <OrganizationSelect organizations={organizations} />,
				},
			]}
		/>
	);
};

OrganizationChangeModal.propTypes = {
	organizationId: PropTypes.number.isRequired,
	open: PropTypes.bool,
	onSubmit: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

OrganizationChangeModal.defaultProps = {
	open: false,
};

export default OrganizationChangeModal;



// WEBPACK FOOTER //
// ./src/components/organization/organizationChangeModal.jsx